/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value != null ? String(value) : '';
  }

  function formatPrescriptionNumber(value, options) {
    var opts = options || {};
    var fallback = opts.fallback != null ? opts.fallback : '-';

    if (value == null || value === '') return fallback;

    var normalized = String(value).trim();
    if (!normalized) return fallback;
    if (normalized === '-' || normalized.toLowerCase() === 'n/a') {
      return opts.naValue || 'N/A';
    }

    var num = Number(normalized);
    if (isNaN(num)) return fallback;

    if (Number.isInteger(num) && Math.abs(num) >= 10) {
      return String(num);
    }

    var fixed = num.toFixed(2);
    if (opts.showPositiveSign && num > 0) return '+' + fixed;
    return fixed;
  }

  function renderPrescriptionTable(rxData) {
    if (!rxData) return;

    var summaryTable = document.querySelector('.table_component');
    if (summaryTable) summaryTable.style.display = '';

    setText('summary-od-sph', formatPrescriptionNumber(rxData.od ? rxData.od.sph : null));
    setText('summary-od-cyl', formatPrescriptionNumber(rxData.od ? rxData.od.cyl : null));
    setText('summary-od-axis', formatPrescriptionNumber(rxData.od ? rxData.od.axis : null));
    setText(
      'summary-od-add',
      formatPrescriptionNumber(rxData.od ? rxData.od.add : null, { showPositiveSign: true, naValue: 'N/A' })
    );
    setText('summary-os-sph', formatPrescriptionNumber(rxData.os ? rxData.os.sph : null));
    setText('summary-os-cyl', formatPrescriptionNumber(rxData.os ? rxData.os.cyl : null));
    setText('summary-os-axis', formatPrescriptionNumber(rxData.os ? rxData.os.axis : null));
    setText(
      'summary-os-add',
      formatPrescriptionNumber(rxData.os ? rxData.os.add : null, { showPositiveSign: true, naValue: 'N/A' })
    );

    var pdEls = document.querySelectorAll('#summary-pd');
    if (rxData.pd) {
      if (rxData.pd.combined) {
        pdEls.forEach(function (el) { el.textContent = formatPrescriptionNumber(rxData.pd.combined); });
      } else if (rxData.pd.left && rxData.pd.right) {
        if (pdEls[0]) pdEls[0].textContent = formatPrescriptionNumber(rxData.pd.left);
        if (pdEls[1]) pdEls[1].textContent = formatPrescriptionNumber(rxData.pd.right);
      }
    }
  }

  function renderPrismDetails(rxData) {
    var prismTable = document.getElementById('summary-prism-details');
    var prismContainer = document.getElementById('summary-prism-container');

    if (!rxData || !rxData.hasPrism || !rxData.prism) {
      if (prismTable) prismTable.style.display = 'none';
      if (prismContainer) prismContainer.style.display = 'none';
      return;
    }

    if (prismTable) prismTable.style.display = '';
    if (prismContainer) prismContainer.style.display = '';

    var p = rxData.prism;
    setText('summary-od-prism-v', formatPrescriptionNumber(p.od ? p.od.vertical : null));
    setText('summary-od-prism-v-dir', p.od ? p.od.vertical_dir : '-');
    setText('summary-od-prism-h', formatPrescriptionNumber(p.od ? p.od.horizontal : null));
    setText('summary-od-prism-h-dir', p.od ? p.od.horizontal_dir : '-');
    setText('summary-os-prism-v', formatPrescriptionNumber(p.os ? p.os.vertical : null));
    setText('summary-os-prism-v-dir', p.os ? p.os.vertical_dir : '-');
    setText('summary-os-prism-h', formatPrescriptionNumber(p.os ? p.os.horizontal : null));
    setText('summary-os-prism-h-dir', p.os ? p.os.horizontal_dir : '-');
  }

  function lensTierDisplayName(usage, tier) {
    var Config = window.OletLens && window.OletLens.Config;
    var data = (Config && Config.LENS_OPTIONS_DATA) || {};
    var row = usage ? data[usage] : null;
    if (!row || !row.length || !tier) return null;
    for (var i = 0; i < row.length; i++) {
      if (row[i].type === tier) return row[i].name;
    }
    return null;
  }

  function renderLensType(type, usage) {
    var container = document.getElementById('summary-lens-container');
    if (!type) {
      if (container) container.style.display = 'none';
      return;
    }
    if (container) container.style.display = '';
    var resolved = lensTierDisplayName(usage, type);
    var label =
      resolved ||
      type.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
    setText('summary-lens-type', label);
  }

  function renderSunglasses(sel) {
    var container = document.getElementById('summary-sunglasses-container');
    if (!container) return;
    if (!sel || !sel.type) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var label = sel.type.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    if (sel.color) label += ' - ' + sel.color.charAt(0).toUpperCase() + sel.color.slice(1);
    setText('summary-lens-color', label);
  }

  function renderAddons(addons) {
    var container = document.getElementById('summary-lens-addons-container');
    if (!container) return;
    if (!addons || !addons.length) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var text = addons.map(function (a) {
      return a.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }).join(', ');
    setText('summary-lens-addons', text);
  }

  function renderPrescriptionImage(state) {
    var container = document.getElementById('summary-prescription-container');
    var imgContainer = document.getElementById('summary-prescription-image-container');
    var img = document.getElementById('summary-prescription-image');
    var pdfContainer = document.getElementById('summary-prescription-pdf-container');
    var pdfLabel = document.getElementById('summary-prescription-pdf-label');

    if (!container || !img || !imgContainer || !pdfContainer) return;

    var preview = state && state.rxFilePreview;
    var url = state && state.rxFileUrl;
    var source = preview || url;

    if (!source) {
      container.style.display = 'none';
      img.removeAttribute('src');
      imgContainer.style.display = 'none';
      pdfContainer.classList.add('hidden');
      return;
    }

    var isPdf = false;
    if (typeof source === 'string') {
      if (source.indexOf('.pdf') !== -1 || source.indexOf('data:application/pdf') === 0) {
        isPdf = true;
      }
    }

    container.style.display = '';

    if (isPdf) {
      // Hide image, show PDF badge
      img.removeAttribute('src');
      imgContainer.style.display = 'none';
      pdfContainer.classList.remove('hidden');

      if (pdfLabel) {
        pdfLabel.textContent = 'Prescription PDF uploaded – click to view';
      }

      pdfContainer.onclick = function () {
        var pdfUrl =
          (window.lensSelectorApp && window.lensSelectorApp.uploadedPrescriptionFileBase64) ||
          (window.lensSelectorApp && window.lensSelectorApp.uploadedPrescriptionFileUrl) ||
          source;

        if (!pdfUrl) return;

        var modal = document.getElementById('pdf-viewer-modal');
        var pdfViewerContainer = document.getElementById('pdf-viewer-container');
        var pdfCanvas = document.getElementById('pdf-canvas');
        var iframe = document.getElementById('pdf-viewer-frame');
        var imageViewer = document.getElementById('image-viewer-frame');

        if (modal) {
          if (imageViewer) imageViewer.classList.add('hidden');
          if (iframe) iframe.classList.add('hidden');

          if (pdfViewerContainer && pdfCanvas && window.renderPDFWithJS) {
            pdfViewerContainer.classList.remove('hidden');
            window.renderPDFWithJS(pdfUrl, pdfCanvas);
            modal.classList.remove('hidden');
            document.body.style.overflow = 'hidden';
          } else if (iframe) {
            iframe.classList.remove('hidden');
            iframe.src = pdfUrl;
            modal.classList.remove('hidden');
            document.body.style.overflow = 'hidden';
          } else {
            window.open(pdfUrl, '_blank');
          }
        } else {
          window.open(pdfUrl, '_blank');
        }
      };
    } else {
      // Image preview path
      pdfContainer.classList.add('hidden');
      imgContainer.style.display = 'block';
      img.src = source;

      img.onclick = function () {
        var imageUrl =
          (window.lensSelectorApp && window.lensSelectorApp.uploadedPrescriptionFileUrl) ||
          (window.lensSelectorApp && window.lensSelectorApp.uploadedPrescriptionFileBase64) ||
          source;

        var modal = document.getElementById('pdf-viewer-modal');
        var pdfViewerContainer = document.getElementById('pdf-viewer-container');
        var iframe = document.getElementById('pdf-viewer-frame');
        var imageViewer = document.getElementById('image-viewer-frame');

        if (modal && imageViewer) {
          if (pdfViewerContainer) pdfViewerContainer.classList.add('hidden');
          if (iframe) iframe.classList.add('hidden');
          imageViewer.classList.remove('hidden');
          imageViewer.src = imageUrl;
          modal.classList.remove('hidden');
          document.body.style.overflow = 'hidden';
        }
      };
    }
  }

  function renderReadingStrength(strength) {
    var el = document.getElementById('summary-magnifier-strength');
    if (!el) return;
    if (!strength) {
      el.style.display = 'none';
      return;
    }
    el.style.display = 'block';
    el.textContent = 'Reading Strength: ' + strength;
  }

  function render(state) {
    var usage = state.usage;

    var summaryTable = document.querySelector('#lens-summary .table_component');

    if (usage === 'reading') {
      if (summaryTable) summaryTable.style.display = 'none';
      var readingData = state.reading || {};
      renderReadingStrength(readingData.strength || readingData.reading_strength || '');
      renderPrismDetails(null);

      if (readingData.pd) {
        var pdEls = document.querySelectorAll('#summary-pd');
        if (readingData.pd.combined) {
          pdEls.forEach(function (el) { el.textContent = formatPrescriptionNumber(readingData.pd.combined); });
        }
      }
    } else if (usage === 'non-prescription') {
      if (summaryTable) summaryTable.style.display = 'none';
      renderReadingStrength(null);
      renderPrismDetails(null);
    } else if (state.prescription) {
      if (summaryTable) summaryTable.style.display = '';
      renderPrescriptionTable(state.prescription);
      renderPrismDetails(state.prescription);
      renderReadingStrength(null);
    }

    renderLensType(state.lensType, state.usage);
    renderSunglasses(state.sunglasses ? { type: state.sunglasses, color: state.sunglassesColor } : null);
    renderAddons(state.addons || []);

    renderPrescriptionImage(state || null);
  }

  window.OletLens.SummaryModule = {
    render: render,
    renderPrescriptionTable: renderPrescriptionTable,
    renderPrismDetails: renderPrismDetails,
    renderLensType: renderLensType,
    renderSunglasses: renderSunglasses,
    renderAddons: renderAddons,
    renderPrescriptionImage: renderPrescriptionImage,
    renderReadingStrength: renderReadingStrength,
  };
})();
